import { Box, CircularProgress, Typography, Paper, Grid } from "@mui/material";
import { camelCaseToSentenceCase } from "../../../helpers/camelCaseToSentenceCase";
import { formatSaleValues } from "../../../helpers/formatingFunctions";
import SalePopup from "../SalePopup/SalePopup";

const SaleStatus = ({
  asset,
  isLoading,
  isError,
  error,
}: {
  asset: any;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Paper
        elevation={0}
        sx={{ p: 2, bgcolor: "error.light", color: "error.contrastText" }}
      >
        <Typography>Error: {(error as Error).message}</Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.5, sm: 3 },
        height: "100%",
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 600,
          color: "primary.main",
          borderBottom: "2px solid",
          borderColor: "primary.main",
          pb: 1,
          mb: 3,
        }}
      >
        Sale Status
      </Typography>
      {asset === null ? (
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography variant="body1" color="text.secondary" align="center">
            This asset is not sold
          </Typography>
          <SalePopup />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {Object.entries(asset)
            .filter(([key]) => !["id", "truckId", "trailerId"].includes(key))
            .map(([key, val]) => (
              <Grid item xs={12} key={key}>
                <Box
                  className="asset-detail-field"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1.5,
                    borderRadius: 1,
                    "&:hover": {
                      bgcolor: "action.hover",
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "text.secondary",
                    }}
                  >
                    {camelCaseToSentenceCase(key)}:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                    }}
                  >
                    {formatSaleValues(key, val as string)}
                  </Typography>
                </Box>
              </Grid>
            ))}
        </Grid>
      )}
    </Paper>
  );
};

export default SaleStatus;
